import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TopPart
  from './TopPart';
import BottomPart
  from './BottomPart';
import { FilterProvider } from './FilterContext';

const styles = () => ({
  root: {
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  top: {
    flexShrink: 0,
  },
  bottom: { flexGrow: 1, minHeight: 0 },
});

const RightSide = ({ className, classes }) => {
  return (
    <FilterProvider>
      <Box className={classNames(classes.root, className)}>
        <TopPart className={classes.top} />
        <BottomPart className={classes.bottom} />
      </Box>
    </FilterProvider>
  );
};

RightSide.defaultProps = {
  className: '',
};

RightSide.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RightSide);
